import _CheckmarkOutline from '@lyearn/icons/dist/cjs/web/CheckmarkOutline';
import React__default from 'react';
import c from 'classnames';
import Checkbox from '../../../Checkbox/Checkbox.js';

var renderSelectedIndicator = function renderSelectedIndicator(params) {
  var config = params.config,
    multiple = params.multiple,
    state = params.state;
  if (multiple) {
    return /*#__PURE__*/React__default.createElement(Checkbox, {
      checked: state.selected,
      className: c('bg-bg-primary rounded-none', config == null ? void 0 : config.Checkbox)
    });
  }
  if (state.selected) {
    return /*#__PURE__*/React__default.createElement(_CheckmarkOutline, {
      className: c('shrink-0', config == null ? void 0 : config.Icon),
      fillColorToken: "icon-active"
    });
  }
  return null;
};

export { renderSelectedIndicator };
//# sourceMappingURL=renderers.js.map
